/**
 * @file AgentTexts.jsx
 * @description AgentTexts component for displaying and managing text conversations.
 * @component AgentTexts
 * @exports AgentTexts - Main component for displaying and managing text conversations.
 */

import React, { useState, useEffect } from "react";
import LinearProgress from '@mui/material/LinearProgress';
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Box
} from "@mui/material";
import { SIZES } from "../../../common/constants/commonConstants.js";
import { TEXTS_TABLE_COLUMNS, TEXTS_TABLE_COLUMNS_KEYS } from "../../../common/constants/agentModule/statusConstants.js";
import { getAgentTexts } from "../../../services/agentModule/agentInfoServices.js";

const AgentTexts = () => {
	const [texts, setTexts] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const agentGUID = localStorage.getItem("userguid");

	useEffect(() => {
		fetchTexts();
	}, []);

	const fetchTexts = async () => {
		setIsLoading(true);
		try {
			const data = await getAgentTexts({ agentGUID });
			setTexts(data || []);
		} catch (error) {
			console.error("Error fetching texts:", error);
		} finally {
			setIsLoading(false);
		}
	};

	const formatDate = (isoDate) => {
		const date = new Date(isoDate);
		return date.toLocaleString();
	};

	return (
		<>
			{isLoading ? (
				<>
					<Box sx={{ width: '100%' }}>
						<LinearProgress />
					</Box>
				</>
			) : (
				<>
					<TableContainer>
						<Table size={SIZES.SMALL}>
							<TableHead>
								<TableRow>
									{TEXTS_TABLE_COLUMNS.map((column) => (
										<TableCell
											key={column.id}
											sx={{
												width:
													column.id === TEXTS_TABLE_COLUMNS_KEYS.FIRSTNAME ? 150 :
													column.id === TEXTS_TABLE_COLUMNS_KEYS.LASTNAME ? 150 :
													column.id === TEXTS_TABLE_COLUMNS_KEYS.CUSTOMER ? 150 :
													column.id === TEXTS_TABLE_COLUMNS_KEYS.RESPONSE ? 200 :
													column.id === TEXTS_TABLE_COLUMNS_KEYS.DATE ? 100 :
													column.id === TEXTS_TABLE_COLUMNS_KEYS.RESPONSEDATE ? 100 : 150,
											}}
										>
											{column.label}
										</TableCell>
									))}
								</TableRow>
							</TableHead>
							<TableBody>
								{texts.length === 0 ? (
									<TableRow>
										<TableCell colSpan={6} align="center">
											No Texts Found
										</TableCell>
									</TableRow>
								) : (
									texts.map((texts, index) => (
										<TableRow key={index}>
											<TableCell>{texts.firstname}</TableCell>
											<TableCell>{texts.lastname}</TableCell>
											<TableCell>{texts.userresponse}</TableCell>
											<TableCell>{texts.cararesponse}</TableCell>
											<TableCell>{formatDate(texts.userresponsetime)}</TableCell>
											<TableCell>{formatDate(texts.cararesponsetime)}</TableCell>
										</TableRow>
									))
								)}
							</TableBody>
						</Table>
					</TableContainer>
				</>
			)}
		</>
	);
};

export default AgentTexts;